import React from 'react';

const Loader = () => {
    return (
      <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-70 z-[9999]">
        <span className="loading loading-spinner text-accent loading-lg"></span>
      </div>
    );
};

export default Loader;